import CollegeDetailsReport from './college-details-report';
import DemographicsReport from './demographics-report';
import FeedbackMetricsReport from './feedback-metrics';
import FeedbackReport from './feedback-report';
import RegistrationsReport from './registrations-report';
import SessionsMetricsReport from './sessions-metrics-report';
import SessionsReport from './sessions-report';
import StudentDetailsReport from './student-details-report';
import UniqueCounselorsReport from './unique-counselors-report';
import UniqueStudentsReport from './unique-students-report';
import CreditsReport from './Credits/credit-report';
import WorkshopsReport from './workshops-report';
import CustomUserTags from './custom-user-tags';

export default class Store {
  initialized = false;

  provides = {
    collegeDetailsReport: new CollegeDetailsReport(),
    credits: new CreditsReport(),
    workshopsReport: new WorkshopsReport(),
    demographicsReport: new DemographicsReport(),
    registrationsReport: new RegistrationsReport(),
    globalMetrics: new SessionsMetricsReport(),
    sessionsMetricsReport: new SessionsMetricsReport(),
    sessionsReport: new SessionsReport(),
    studentDetailsReport: new StudentDetailsReport(),
    uniqueStudents: new UniqueStudentsReport(),
    uniqueCounselors: new UniqueCounselorsReport(),
    outOfPocketStudents: new UniqueStudentsReport(),
    feedbackReport: new FeedbackReport(),
    feedbackMetrics: new FeedbackMetricsReport(),
    customUserTags: new CustomUserTags()
  }

  initialize($http, schoolId){
    Object.values(this.provides).forEach((r) => {
      try {
        // Some sort of $validator gets tacked into Store.
        // So lets ignore anything without an initialize.
        if(r.initialize)
          r.initialize($http, schoolId);
      } catch (e) {
        console.error(e);
      }
    });
    this.initialized = true;
  }
}